import { useState } from "react";
import { Alert, AlertColor, Box, Typography } from "@mui/material";
import authService from "../../../../../services/auth.service";
import RegisterForm from "../../../../../components/Shared/RegisterForm";
import { useTheme } from '@mui/material/styles';
import { statratBlack, statratGray } from "../../../../../config/constants";

const ProfileSettings = () => {
    const theme = useTheme();

    const [alert, setAlert] = useState("");
    const [severity, setSeverity] = useState<AlertColor>("success");
    const [isLoading, setIsLoading] = useState(false);

    const handleSaveProfile = (props: any) => {
        authService.update(
            props.id,
            props.businessName,
            props.email,
            props.password,
            props.mobile,
            props.addressLine1,
            props.addressLine2,
            props.country,
            props.state,
            props.city,
            props.postalCode
        )
        .then(response => {
            if (response.c === 1) {
                setSeverity("success");
                setAlert("Successfully updated profile");
            } else {
                setSeverity("error");
                setAlert(response.message);
            }
        });
    }

    return (
        <Box display='flex' flexDirection='column' gap={3}>
            <Typography variant="h5">Profile Settings</Typography>
            <RegisterForm
                handleSignup={handleSaveProfile}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                autoFillColor={theme.palette.mode === "light" ? statratGray : statratBlack}
            />
            { alert !== "" && 
                <Alert variant="filled" severity={severity} sx={{ width: '100%' }}>{alert}</Alert>
            }
        </Box>
    )
}

export default ProfileSettings;
